import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import SettingsContext from "./SettingsContext";

const useSettingsContext = () => useDefinedContext(SettingsContext);

export default useSettingsContext;
